import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'player-skill-filter',
    templateUrl: './player-skill-filter.modal.html',
    styleUrls: ['./player-skill-filter.modal.scss'],
})
export class PlayerSkillFilterModal implements OnInit{
    
    @Input() minAge: number;

    @Input() maxAge: number;

    readonly minValue: number = 10;

    readonly maxValue: number = 100;

    formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal) {}
    
    ngOnInit(): void {
        this.formGroup = new FormGroup({
            staminaMinValueFormControl: new FormControl(),
            staminaMaxValueFormControl: new FormControl(),
            forceMinValueFormControl: new FormControl(),
            forceMaxValueFormControl: new FormControl(),
            speedMinValueFormControl: new FormControl(),
            speedMaxValueFormControl: new FormControl(),
            dribleMinValueFormControl: new FormControl(),
            dribleMaxValueFormControl: new FormControl(),
            freekickMinValueFormControl: new FormControl(),
            freekickMaxValueFormControl: new FormControl(),
            cornerMinValueFormControl: new FormControl(),
            cornerMaxValueFormControl: new FormControl(),
            accuracyShotMinValueFormControl: new FormControl(),
            accuracyShotMaxValueFormControl: new FormControl(),
            powerShotMinValueFormControl: new FormControl(),
            powerShotMaxValueFormControl: new FormControl(),
            visionMinValueFormControl: new FormControl(),
            visionMaxValueFormControl: new FormControl(),
            positionMinValueFormControl: new FormControl(),
            positionMaxValueFormControl: new FormControl(),
            headingMinValueFormControl: new FormControl(),
            headingMaxValueFormControl: new FormControl(),
            tacklingMinValueFormControl: new FormControl(),
            tacklingMaxValueFormControl: new FormControl(),
            crossMinValueFormControl: new FormControl(),
            crossMaxValueFormControl: new FormControl(),
            passMinValueFormControl: new FormControl(),
            passMaxValueFormControl: new FormControl(),
            gkOutMinValueFormControl: new FormControl(),
            gkOutMaxValueFormControl: new FormControl(),
            gkThrowMinValueFormControl: new FormControl(),
            gkThrowMaxValueFormControl: new FormControl(),
            technickMinValueFormControl: new FormControl(),
            technickMaxValueFormControl: new FormControl(),
            positionShotMaxValueFormControl: new FormControl(),
            positionShotMinValueFormControl: new FormControl(),
            gkHandlingMaxValueFormControl: new FormControl(),
            gkHandlingMinValueFormControl: new FormControl(),
            gkReactionMaxValueFormControl: new FormControl(),
            gkReactionMinValueFormControl: new FormControl(),
        })
    }

   

    submit() {
        let result: any = {
            minStamina: undefined,
            maxStamina: undefined,
            minForce: undefined,
            maxForce: undefined,
            minSpeed: undefined,
            maxSpeed: undefined,
            minDrible: undefined,
            maxDrible: undefined,
            minFreekick: undefined,
            maxFreekick: undefined,
            minCorner: undefined,
            maxCorner: undefined,
            minAccuracy: undefined,
            maxAccuracy: undefined,
            minPowerShot: undefined,
            maxPowerShot: undefined,
            minVision: undefined,
            maxVision: undefined,
            minPosition: undefined,
            maxPosition: undefined,
            minHeading: undefined,
            maxHeading: undefined,
            minTackling: undefined,
            maxTackling: undefined,
            minCross: undefined,
            maxCross: undefined,
            minPass: undefined,
            maxPass: undefined,
            minGkOut: undefined,
            maxGkOut: undefined,
            minGkThrow: undefined,
            maxGkThrow: undefined,
            minTechnick: undefined,
            maxTechnick: undefined,
            minGkHandling: undefined,
            maxGkHandling: undefined,
            minGkReaction: undefined,
            maxGkReaction: undefined,
        }

      if (this.formGroup.controls.staminaMinValueFormControl.value) {
        result.minStamina = this.formGroup.controls.staminaMinValueFormControl.value
      }

      if (this.formGroup.controls.staminaMaxValueFormControl.value) {
        result.maxStamina = this.formGroup.controls.staminaMaxValueFormControl.value
      }

      if (this.formGroup.controls.forceMinValueFormControl.value) {
        result.minForce = this.formGroup.controls.forceMinValueFormControl.value
      }

      if (this.formGroup.controls.forceMaxValueFormControl.value) {
        result.maxForce = this.formGroup.controls.forceMaxValueFormControl.value
      }

      if (this.formGroup.controls.speedMinValueFormControl.value) {
        result.minSpeed = this.formGroup.controls.speedMinValueFormControl.value
      }

      if (this.formGroup.controls.speedMaxValueFormControl.value) {
        result.maxSpeed = this.formGroup.controls.speedMaxValueFormControl.value
      }

      if (this.formGroup.controls.dribleMinValueFormControl.value) {
        result.minSpeed = this.formGroup.controls.dribleMinValueFormControl.value
      }

      if (this.formGroup.controls.dribleMaxValueFormControl.value) {
        result.maxSpeed = this.formGroup.controls.dribleMaxValueFormControl.value
      }

      if (this.formGroup.controls.freekickMinValueFormControl.value) {
        result.minFreekick = this.formGroup.controls.freekickMinValueFormControl.value
      }

      if (this.formGroup.controls.freekickMaxValueFormControl.value) {
        result.maxFreekick = this.formGroup.controls.freekickMaxValueFormControl.value
      }

      if (this.formGroup.controls.cornerMinValueFormControl.value) {
        result.minCorner = this.formGroup.controls.cornerMinValueFormControl.value
      }

      if (this.formGroup.controls.cornerMaxValueFormControl.value) {
        result.maxCorner = this.formGroup.controls.cornerMaxValueFormControl.value
      }
      
      if (this.formGroup.controls.accuracyShotMinValueFormControl.value) {
        result.minAccuracy = this.formGroup.controls.accuracyShotMinValueFormControl.value
      }

      if (this.formGroup.controls.accuracyShotMaxValueFormControl.value) {
        result.maxAccuracy = this.formGroup.controls.accuracyShotMaxValueFormControl.value
      }

      if (this.formGroup.controls.powerShotMinValueFormControl.value) {
        result.minPowerShot = this.formGroup.controls.powerShotMinValueFormControl.value
      }

      if (this.formGroup.controls.powerShotMaxValueFormControl.value) {
        result.maxPowerShot = this.formGroup.controls.powerShotMaxValueFormControl.value
      }

      if (this.formGroup.controls.visionMinValueFormControl.value) {
        result.minVision = this.formGroup.controls.visionMinValueFormControl.value
      }

      if (this.formGroup.controls.visionMaxValueFormControl.value) {
        result.maxVision = this.formGroup.controls.visionMaxValueFormControl.value
      }

      if (this.formGroup.controls.positionMinValueFormControl.value) {
        result.minPosition = this.formGroup.controls.positionMinValueFormControl.value
      }

      if (this.formGroup.controls.positionMaxValueFormControl.value) {
        result.maxPosition = this.formGroup.controls.positionMaxValueFormControl.value
      }

      if (this.formGroup.controls.headingMinValueFormControl.value) {
        result.minHeading = this.formGroup.controls.headingMinValueFormControl.value
      }

      if (this.formGroup.controls.headingMaxValueFormControl.value) {
        result.maxHeading = this.formGroup.controls.headingMaxValueFormControl.value
      }

       if (this.formGroup.controls.tacklingMinValueFormControl.value) {
        result.minTackling = this.formGroup.controls.tacklingMinValueFormControl.value
      }

      if (this.formGroup.controls.tacklingMaxValueFormControl.value) {
        result.maxTackling = this.formGroup.controls.tacklingMaxValueFormControl.value
      }

      if (this.formGroup.controls.crossMinValueFormControl.value) {
        result.minCross = this.formGroup.controls.crossMinValueFormControl.value
      }

      if (this.formGroup.controls.crossMaxValueFormControl.value) {
        result.maxCross = this.formGroup.controls.crossMaxValueFormControl.value
      }

      if (this.formGroup.controls.passMinValueFormControl.value) {
        result.minPass = this.formGroup.controls.passMinValueFormControl.value
      }

      if (this.formGroup.controls.passMaxValueFormControl.value) {
        result.maxPass = this.formGroup.controls.passMaxValueFormControl.value
      }

      if (this.formGroup.controls.gkOutMinValueFormControl.value) {
        result.minGkOut = this.formGroup.controls.gkOutMinValueFormControl.value
      }

      if (this.formGroup.controls.gkOutMaxValueFormControl.value) {
        result.maxGkOut = this.formGroup.controls.gkOutMaxValueFormControl.value
      }

      if (this.formGroup.controls.gkThrowMinValueFormControl.value) {
        result.minGkThrow = this.formGroup.controls.gkThrowMinValueFormControl.value
      }

      if (this.formGroup.controls.gkThrowMaxValueFormControl.value) {
        result.maxGkThrow = this.formGroup.controls.gkThrowMaxValueFormControl.value
      }

      if (this.formGroup.controls.technickMinValueFormControl.value) {
        result.minTechnick = this.formGroup.controls.technickMinValueFormControl.value
      }

      if (this.formGroup.controls.technickMaxValueFormControl.value) {
        result.maxTechnick = this.formGroup.controls.technickMaxValueFormControl.value
      }

      if (this.formGroup.controls.gkHandlingMaxValueFormControl.value) {
        result.minGkHandling = this.formGroup.controls.gkHandlingMaxValueFormControl.value
      }

      if (this.formGroup.controls.gkHandlingMinValueFormControl.value) {
        result.maxGkHandling = this.formGroup.controls.gkHandlingMinValueFormControl.value
      }

      if (this.formGroup.controls.gkReactionMaxValueFormControl.value) {
        result.minGkReaction = this.formGroup.controls.gkReactionMaxValueFormControl.value
      }

      if (this.formGroup.controls.gkReactionMinValueFormControl.value) {
        result.maxGkReaction = this.formGroup.controls.gkReactionMinValueFormControl.value
      }

        this.activeModal.close(result);
    }
}